import { useContext } from 'react';
import styled from 'styled-components';
import { CartContext } from 'context-providers/cart-provider';
import { discountAppliesToProduct } from 'lib/utils/coupons/discount-applies-to-product';
import PdpLocale from 'locale/en/pdp.json';

type PromoCodeIndicatorProps = {
  // Shopify product gid, e.g. "gid://shopify/Product/123"
  productId?: string | null;
  hidePromo?: boolean;
  promoCodeOverride?: string;
};

const Indicator = styled.div`
  text-align: center;
  background-color: var(--guidance-secondary);
  padding: var(--spacing-8) 12px;
  margin-top: 15px;
  margin-bottom: 15px;
  border-radius: var(--radius-lg);
  font-size: var(--font-size-350);
`;

// The little banner above a PDP CTA confirming the active promo code
const PromoCodeIndicator = ({
  productId,
  hidePromo,
  promoCodeOverride,
}: PromoCodeIndicatorProps) => {
  const { promoCode, promoCodeDiscountInfo } = useContext(CartContext);

  const couponApplicable = discountAppliesToProduct(
    productId,
    promoCodeDiscountInfo?.items,
  );

  if (couponApplicable && !hidePromo && promoCode) {
    return (
      <Indicator className='promoCodeIndicator'>
        {PdpLocale.promo_code_indicator.replace(
          'PROMO_CODE',
          promoCode.toUpperCase(),
        )}
      </Indicator>
    );
  }

  if (promoCodeOverride) {
    return (
      <Indicator className='promoCodeIndicator'>{promoCodeOverride}</Indicator>
    );
  }

  return null;
};

export default PromoCodeIndicator;
